/**
 * NodeBrandImage
 * Renders the right-side vendor brand image inside a node header.
 * Supports SVG and raster formats via a standard <img> tag.
 * Renders nothing when headerImageUrl is absent or fails to load.
 */

import React from 'react';

interface NodeBrandImageProps {
  /** URL to the vendor icon — SVG or raster PNG/JPG. Renders nothing when absent. */
  headerImageUrl?: string;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

export const NodeBrandImage: React.FC<NodeBrandImageProps> = ({
  headerImageUrl,
  size = 16,
  className,
  style,
}) => {
  if (!headerImageUrl) return null;

  return (
    <img
      src={headerImageUrl}
      width={size}
      height={size}
      className={className}
      style={{
        objectFit: 'contain',
        flexShrink: 0,
        borderRadius: '3px',
        ...style,
      }}
      alt=""
      draggable={false}
      loading="lazy"
      onError={(e) => {
        (e.currentTarget as HTMLImageElement).style.display = 'none';
      }}
    />
  );
};
